(function () {
  if (window.MerakiMoveEffect?.destroyAll) {
    window.MerakiMoveEffect.destroyAll();
  }

  // 判断加载类型：'navigate' | 'reload' | 'back_forward'
  function getLoadType() {
    const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav && nav.type) return nav.type;
    if (performance.navigation) {
      const t = performance.navigation.type;
      if (t === performance.navigation.TYPE_RELOAD) return 'reload';
      if (t === performance.navigation.TYPE_BACK_FORWARD) return 'back_forward';
      return 'navigate';
    }
    return 'navigate';
  }

  function collapseAllTracks(root = document) {
    root.querySelectorAll('[data-move-effect-track]').forEach((t) => {
      // 已移除：不再添加 no-sticky 类
      // const sticky = t.querySelector('.move-effect-sticky-viewport');
      // if (sticky) sticky.classList.add('no-sticky');
      t.classList.add('move-effect-track-collapsed');
    });
  }

  function uncollapseAllTracks(root = document) {
    root.querySelectorAll('[data-move-effect-track]').forEach((t) => {
      const sticky = t.querySelector('.move-effect-sticky-viewport');
      if (sticky) sticky.classList.remove('no-sticky');
      t.classList.remove('move-effect-track-collapsed');
    });
  }

  function setPersistDone() {
    try { sessionStorage.setItem('move_effect_done', '1'); } catch (_) {}
  }
  function isPersistDone() {
    try { return sessionStorage.getItem('move_effect_done') === '1'; } catch (_) { return false; }
  }
  function applyPersistDone(root = document) {
    if (!isPersistDone()) return;
    root.querySelectorAll('[data-move-effect-track]').forEach((t) => {
      // 已移除：不再添加 no-sticky 类
      // const sticky = t.querySelector('.move-effect-sticky-viewport');
      // if (sticky) sticky.classList.add('no-sticky');
      t.classList.add('move-effect-track-collapsed');
    });
  }

  // Header 抑制：在回滚期间防止显示
  function preventHeaderReveal(ms = 200) {
    const header = document.querySelector('sticky-header');
    if (header) {
      header.dispatchEvent(new CustomEvent('preventHeaderReveal', { detail: { ms } }));
    }
    document.body.classList.add('header-locked');
    setTimeout(() => document.body.classList.remove('header-locked'), ms);
  }

  function getHeaderOffset() {
    const header = document.querySelector('sticky-header, .section-header');
    return header ? (header.offsetHeight || 0) : 0;
  }

  // 核心滚动还原：保存与恢复
  let scrollSaveLockedUntil = 0; // 回滚时临时锁定保存，避免保存回滚位置
  let isBackNavigation = false; // 标记是否是返回场景（back_forward 或 bfcache 恢复）

  function setupScrollSave() {
    // 保存当前位置（站内链接点击/离开前兜底）
    document.addEventListener('click', (e) => {
      const a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      const url = new URL(a.href, location.origin);
      if (url.origin === location.origin) {
        // 回滚锁定期间不保存
        if (Date.now() < scrollSaveLockedUntil) return;
        sessionStorage.setItem('meraki_prev_scroll_y', String(window.scrollY));
      }
    }, { capture: true });

    window.addEventListener('beforeunload', () => {
      // 回滚锁定期间不保存
      if (Date.now() < scrollSaveLockedUntil) return;
      sessionStorage.setItem('meraki_prev_scroll_y', String(window.scrollY));
    });
  }

  // 使用浏览器默认的 scrollRestoration = 'auto'，不再手动恢复滚动位置

  class MoveEffectSection {
    constructor(track) {
      this.track = track;
      this.sectionId = track.dataset.sectionId || track.id;
      this.scene = track.querySelector('[data-move-effect-scene]');
      if (!this.scene) return;
      // 所在的宿主 section 以及下一个 section（用于到顶触发折叠）
      this.hostSection = this.track.closest('section') || null;
      this.nextSection = this.hostSection ? this.hostSection.nextElementSibling : null;
      // 获取 .meraki-move-effect 元素用于读取 CSS 变量
      this.moveEffectElement = this.track.closest('.meraki-move-effect') || this.track;
      this.stickyViewport = this.track.querySelector('.move-effect-sticky-viewport');

      this.circles = this.scene.querySelectorAll('.move-effect-circle');
      this.machineContainer = this.scene.querySelector('.move-effect-machine-container');
      this.contentContainer = this.scene.querySelector('.move-effect-content');

      // Safari（尤其模拟器）地址栏显示/隐藏时，元素布局高度可能被压缩（即使 innerHeight/visualViewport.height 不变）。
      // 这里维护一个“稳定视口高度”（按方向可重置，只增不减），并写入 sticky viewport 的 inline height，保证高度与动效都稳定。
      this.stableViewportHeightPx = 0;
      this.lastViewportWidth = window.innerWidth;
      // 记录固定的 100lvh 值（地址栏隐藏时的视口高度），用于与设计稿高度比较
      this.fixedLvhHeightPx = 0;
      this.initFixedLvhHeight();
      this.syncStableViewportHeight(true);

      this.currentProgress = 0;
      this.targetProgress = 0;
      this.animationFrameId = null;
      this.smoothFactor = 0.12;

      this.positions = this.readPositions();
      this.lastIsDesktop = this.isDesktop();

      // 找到下一个 section（Shopify 主题中 section 包在 .shopify-section 内）
      const hostWrapper = this.track.closest('.shopify-section') || this.track;
      this.nextSection = hostWrapper.nextElementSibling;

      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);

      // 如果初始进度为 0，不调用 applyAnimation，让 CSS 初始位置生效
      this.syncStableViewportHeight(false);
      const initialProgress = this.calculateProgress();
      if (initialProgress === 0) {
        // 如果初始进度为 0，不调用 applyAnimation，让 CSS 初始位置生效
        // 只读取位置信息，不应用动画
      } else {
        // 如果已经有滚动进度，才调用 applyAnimation
        this.applyAnimation(initialProgress);
      }
      this.handleScroll();

      this.featureLocked = false;
      this.nextSectionPlaceholder = null;
      this.nextSectionOriginalStyle = null;
    }

    destroy() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      cancelAnimationFrame(this.animationFrameId);
      this.unlockNextSection();
      // 清理 100lvh 监听器
      if (this._cleanupLvhListeners) {
        this._cleanupLvhListeners();
        this._cleanupLvhListeners = null;
      }
    }

    isDesktop() {
      return window.innerWidth >= 990;
    }

    getScaleFactor() {
      const varName = this.isDesktop() ? '--scale-factor-desktop' : '--scale-factor-mobile';
      const value = getComputedStyle(this.scene).getPropertyValue(varName).trim();
      const parsed = parseFloat(value);

      if (isNaN(parsed) || !parsed) {
        const screenWidth = window.innerWidth;
        if (this.isDesktop()) {
          return Math.min(1, screenWidth / 1920);
        }
        if (screenWidth < 750) {
          return Math.max(0.5, Math.min(1, screenWidth / 750));
        }
        return 1;
      }

      return parsed;
    }

    getCSSVar(name) {
      // 优先从 .meraki-move-effect 读取 CSS 变量（变量定义在此元素上）
      const moveEffectValue = getComputedStyle(this.moveEffectElement).getPropertyValue(name).trim();
      if (moveEffectValue) {
        return parseFloat(moveEffectValue.replace('px', '')) || 0;
      }
      // 回退到 scene 读取
      const sceneValue = getComputedStyle(this.scene).getPropertyValue(name).trim();
      return parseFloat(sceneValue.replace('px', '')) || 0;
    }

    // 获取当前视口高度（会随地址栏变化）
    computeViewportHeightPx() {
      const vv = window.visualViewport;
      const h = vv && typeof vv.height === 'number' ? vv.height : window.innerHeight;
      return Math.max(0, Math.round(h));
    }

    // 初始化固定的 100lvh 值（地址栏隐藏时的视口高度）
    initFixedLvhHeight() {
      const currentH = this.computeViewportHeightPx();
      // 如果还没有记录，或者当前值更大，则更新（确保记录的是地址栏隐藏时的最大值）
      if (this.fixedLvhHeightPx <= 0 || currentH > this.fixedLvhHeightPx) {
        this.fixedLvhHeightPx = currentH;
      }
      
      // 监听 visualViewport 变化，持续更新最大值（确保记录 100lvh 的固定值）
      if (window.visualViewport) {
        const updateMaxLvh = () => {
          const h = window.visualViewport.height;
          if (typeof h === 'number' && h > this.fixedLvhHeightPx) {
            this.fixedLvhHeightPx = h;
          }
        };
        window.visualViewport.addEventListener('resize', updateMaxLvh);
        window.visualViewport.addEventListener('scroll', updateMaxLvh);
        // 存储清理函数，在 destroy 时调用
        this._cleanupLvhListeners = () => {
          window.visualViewport.removeEventListener('resize', updateMaxLvh);
          window.visualViewport.removeEventListener('scroll', updateMaxLvh);
        };
      }
    }

    // 获取固定的 100lvh 值（地址栏隐藏时的视口高度，用于与设计稿高度比较）
    getFixedLvhHeight() {
      // 如果还没有初始化，返回当前值
      if (this.fixedLvhHeightPx <= 0) {
        const currentH = this.computeViewportHeightPx();
        this.fixedLvhHeightPx = currentH;
        return currentH;
      }
      return this.fixedLvhHeightPx;
    }

    getScrollTop() {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }

    // 获取元素相对 document 的顶部位置（不依赖 getBoundingClientRect，避免 iOS Safari 地址栏导致 rect 变化）
    getDocumentTop(el) {
      let top = 0;
      let node = el;
      while (node) {
        top += node.offsetTop || 0;
        node = node.offsetParent;
      }
      return top;
    }

    // - resetOnOrientationOrFirst: true 时强制重置 stable 高度
    // - 返回值：此次是否发生了“稳定高度”变化
    syncStableViewportHeight(resetOnOrientationOrFirst = false) {
      const w = window.innerWidth;
      // 使用固定的 100lvh 值（地址栏隐藏时的视口高度），而不是会变化的 visualViewport.height
      const fixedLvh = this.getFixedLvhHeight();

      // 计算设计稿高度（与 CSS 的 max(设计稿高度, 100lvh) 保持一致）
      const desktop = this.isDesktop();
      const scaleFactor = this.getScaleFactor();
      const designHeight = desktop ? 1000 : 1346; // 桌面端 1000px，移动端 1346px
      const designHeightScaled = designHeight * scaleFactor;
      
      // 稳定高度 = max(设计稿高度, 100lvh)，与 CSS 逻辑一致
      const targetHeight = Math.max(designHeightScaled, fixedLvh);

      const widthChanged = typeof this.lastViewportWidth === 'number' ? Math.abs(w - this.lastViewportWidth) >= 2 : true;
      const shouldReset = resetOnOrientationOrFirst || this.stableViewportHeightPx <= 0 || widthChanged;

      let nextStable = this.stableViewportHeightPx;
      if (shouldReset) {
        nextStable = targetHeight;
      } else {
        // 只增不减：忽略地址栏导致的“变小”，但确保不低于设计稿高度
        nextStable = Math.max(this.stableViewportHeightPx, targetHeight);
      }

      const changed = nextStable !== this.stableViewportHeightPx || w !== this.lastViewportWidth;
      this.stableViewportHeightPx = nextStable;
      this.lastViewportWidth = w;

      if (this.stickyViewport && this.stableViewportHeightPx > 0) {
        this.stickyViewport.style.height = `${this.stableViewportHeightPx}px`;
      }

      return changed;
    }

    readPositions() {
      const desktop = this.isDesktop();
      const suffix = desktop ? '-desktop' : '';
      const positions = {};

      for (let i = 1; i <= 15; i++) {
        positions[`circle${i}InitialLeft`] = this.getCSSVar(`--circle-${i}-initial-left${suffix}`);
        positions[`circle${i}InitialTop`] = this.getCSSVar(`--circle-${i}-initial-top${suffix}`);
        positions[`circle${i}InitialOpacity`] = this.getCSSVar(`--circle-${i}-initial-opacity${suffix}`) || 0;
        positions[`circle${i}EndLeft`] = this.getCSSVar(`--circle-${i}-end-left${suffix}`);
        
        // 桌面端：根据实际容器高度动态调整 circle 的 end-top 值（以 1000px 为基准）
        if (desktop) {
          const designHeight = 1000; // 桌面端设计稿高度
          const scaleFactor = this.getScaleFactor();
          const actualContainerHeight = this.stickyViewport ? this.stickyViewport.offsetHeight : window.innerHeight;
          const designHeightScaled = designHeight * scaleFactor;
          
          // 如果实际容器高度大于设计稿高度，按比例调整（只应用20%的调整量）
          if (actualContainerHeight > designHeightScaled) {
            const ratio = actualContainerHeight / designHeightScaled;
            const baseEndTop = this.getCSSVar(`--circle-${i}-end-top${suffix}`);
            // 调整量只取20%：base + (base * (ratio - 1) * 0.2) = base * (1 + (ratio - 1) * 0.2)
            positions[`circle${i}EndTop`] = baseEndTop * (1 + (ratio - 1) * 0.2);
          } else {
            positions[`circle${i}EndTop`] = this.getCSSVar(`--circle-${i}-end-top${suffix}`);
          }
        } else {
          positions[`circle${i}EndTop`] = this.getCSSVar(`--circle-${i}-end-top${suffix}`);
        }
        
        positions[`circle${i}EndOpacity`] = this.getCSSVar(`--circle-${i}-end-opacity${suffix}`) || 0.8;
      }

      // Content 终点即初始（content 不参与动效）
      positions.contentInitialTop = this.getCSSVar(`--content-end-top${suffix}`) || 100;
      positions.contentEndTop = this.getCSSVar(`--content-end-top${suffix}`) || 100;

      // Machine 定位：移动端和桌面端都使用 bottom 定位
      const baseMachineInitialBottom = this.getCSSVar(`--machine-initial-bottom${suffix}`);
      const baseMachineEndBottom = this.getCSSVar(`--machine-end-bottom${suffix}`);
      
      positions.machineInitialBottom = baseMachineInitialBottom;
      
      if (desktop) {
        // 桌面端：使用 bottom 定位
        // 根据实际容器高度动态调整咖啡机的移动距离
        const designHeight = 1000; // 桌面端设计稿高度
        const scaleFactor = this.getScaleFactor();
        const actualContainerHeight = this.stickyViewport ? this.stickyViewport.offsetHeight : window.innerHeight;
        const designHeightScaled = designHeight * scaleFactor;
        
        // 根据容器高度选择不同的基准终点：
        // - 高度小于1000px时，基准终点是-350px
        // - 高度大于等于1000px时，基准终点是0px
        const dynamicBaseEndBottom = actualContainerHeight < designHeight ? -350 : 0;
        
        // 计算基准移动距离：动态基准终点 - 起点
        const baseMoveDistance = dynamicBaseEndBottom - baseMachineInitialBottom;
        
        // 根据实际容器高度与设计稿高度（1000px）的比例，动态调整移动距离（直接按比例计算，取消20%限制）
        // 注意：使用 designHeight（1000px）作为基准，而不是 designHeightScaled，以确保在小于 1000px 时也能正确调整
        // 确保 baseMoveDistance 是有效数值（不为 null、undefined 或 NaN）
        if (baseMoveDistance !== null && baseMoveDistance !== undefined && !isNaN(baseMoveDistance) && isFinite(baseMoveDistance) && actualContainerHeight > 0 && designHeight > 0) {
          const ratio = actualContainerHeight / designHeight;
          // 直接按比例计算移动距离（取消20%限制）
          const adjustedMoveDistance = baseMoveDistance * ratio;
          // 调整后的终点 = 起点 + 调整后的移动距离
          let calculatedEndBottom = baseMachineInitialBottom + adjustedMoveDistance;
          
          // 限制：咖啡机顶部不能超过第一排circle的底部（circle 1-5的end-top都是297px）
          // 咖啡机顶部位置 = 容器高度 - bottom - 咖啡机高度
          // 第一排circle底部位置 = circle的end-top + circle的高度
          // 限制条件：咖啡机顶部 ≤ 第一排circle底部
          // 即：容器高度 - bottom - 咖啡机高度 ≤ circle的end-top + circle的高度
          // 即：bottom ≥ 容器高度 - circle的end-top - circle的高度 - 咖啡机高度
          const circle1EndTop = this.getCSSVar(`--circle-1-end-top${suffix}`); // 297px（设计稿值）
          const circleSize = this.getCSSVar(`--circle-size${suffix}`); // 169.58px（桌面端设计稿值）
          const machineHeight = this.getCSSVar(`--machine-height${suffix}`); // 1006px（设计稿值）
          
          if (circle1EndTop !== null && !isNaN(circle1EndTop) && 
              circleSize !== null && !isNaN(circleSize) && 
              machineHeight !== null && !isNaN(machineHeight)) {
            // 计算最大允许的bottom值（设计稿值）
            // 实际值：actualContainerHeight - bottom（实际值） - machineHeight（实际值） ≤ (circle1EndTop + circleSize)（实际值）
            // 转换为设计稿值：actualContainerHeight - bottom（设计稿值）× scaleFactor - machineHeight（设计稿值）× scaleFactor ≤ (circle1EndTop + circleSize)（设计稿值）× scaleFactor
            // 简化：actualContainerHeight / scaleFactor - bottom（设计稿值） - machineHeight（设计稿值） ≤ circle1EndTop（设计稿值） + circleSize（设计稿值）
            // 即：bottom（设计稿值） ≥ actualContainerHeight / scaleFactor - machineHeight（设计稿值） - circle1EndTop（设计稿值） - circleSize（设计稿值）
            const circle1Bottom = circle1EndTop + circleSize; // 第一排circle底部位置（设计稿值）
            const maxBottomDesign = (actualContainerHeight / scaleFactor) - machineHeight - circle1Bottom;
            // 如果计算出的终点超过了限制，则使用限制值
            if (calculatedEndBottom > maxBottomDesign) {
              calculatedEndBottom = maxBottomDesign;
            }
          }
          
          positions.machineEndBottom = calculatedEndBottom;
        } else {
          // 如果条件不满足，使用基准值
          positions.machineEndBottom = baseMachineEndBottom;
        }
        
        if (!positions.machineInitialBottom && positions.machineInitialBottom !== 0) {
          positions.machineInitialBottom = this.getCSSVar(`--machine-initial-top${suffix}`) || 541;
        }
        if (!positions.machineEndBottom && positions.machineEndBottom !== 0) {
          positions.machineEndBottom = this.getCSSVar(`--machine-end-top${suffix}`) || 0;
        }
      } else {
        // 移动端：初始位置和终点位置都使用 bottom 定位
        // 初始位置：--machine-initial-bottom: -300px（CSS 中定义，不做调整）
        // 终点位置：根据第三排 circle（circle 12）的 end-top 动态计算 bottom 值
        const circle12EndTop = this.getCSSVar(`--circle-12-end-top${suffix}`);
        if (circle12EndTop !== null && !isNaN(circle12EndTop)) {
          // 使用稳定容器高度（避免 Safari 地址栏导致 offsetHeight 短暂波动）
          // 与 calculateProgress() 保持一致，使用稳定高度而不是 offsetHeight
          const actualContainerHeight = this.stableViewportHeightPx || this.computeViewportHeightPx();
          const scaleFactor = this.getScaleFactor();
          const machineHeight = this.getCSSVar('--machine-height') || 782;
          
          // 计算实际应用的 circle 12 end-top 和咖啡机高度
          const actualCircle12EndTop = circle12EndTop * scaleFactor;
          const actualMachineHeight = machineHeight * scaleFactor;
          
          // 计算终点 bottom（实际值）：稳定容器高度 - circle 12 的实际 end-top - 咖啡机的实际高度
          // 这样咖啡机的顶部会与 circle 12 的顶部对齐
          // 注意：这里计算的是实际值，不需要再乘以 scale-factor
          positions.machineEndBottom = (actualContainerHeight - actualCircle12EndTop - actualMachineHeight) / scaleFactor;
        } else {
          // 回退：如果无法获取 circle 12 的位置，使用默认值
          positions.machineEndBottom = this.getCSSVar(`--machine-end-bottom${suffix}`);
          if (!positions.machineEndBottom && positions.machineEndBottom !== 0) {
            positions.machineEndBottom = 0;
          }
        }
      }

      return positions;
    }

    calculateProgress() {
      const viewportHeight = this.stableViewportHeightPx || this.computeViewportHeightPx();
      const scrollTop = this.getScrollTop();
      const trackTop = this.getDocumentTop(this.track);

      if (scrollTop <= trackTop) return 0;

      const scrolled = Math.max(0, scrollTop - trackTop);
      
      // 动画完成距离 = viewport 高度
      const animEndDistance = Math.max(1, viewportHeight);
      
      // 计算进度：允许回退，progress 范围 0-1
      return Math.min(1, scrolled / animEndDistance);
    }

    collapseTrack() {
      // 已移除：不再添加 no-sticky 类
      // const sticky = this.track.querySelector('.move-effect-sticky-viewport');
      // if (sticky) sticky.classList.add('no-sticky');
    }

    // 已废弃：不再执行回滚和伪元素隐藏
    // finishAndRollback() {
    //   // 已处理过则跳过
    //   if (this.collapsed) return;
    //   
    //   // 取消 sticky
    //   this.collapseTrack();
    //   // 隐藏 after，移除多余占位
    //   this.track.classList.add('move-effect-track-collapsed');
    //   this.collapsed = true;
    //   setPersistDone();
    // }

    handleScroll() {
      // 某些 Safari 场景下高度变化未必触发预期的 resize，滚动前也同步一次稳定高度
      this.syncStableViewportHeight(false);
      const progress = this.calculateProgress();
      this.setTargetProgress(progress);
      const shouldLockFeature = this.isTrackSticky();
      if (shouldLockFeature) {
        this.lockNextSection();
      } else {
        this.unlockNextSection();
      }
      
    }

    setTargetProgress(p) {
      this.targetProgress = Math.max(0, Math.min(1, p));
      if (this.animationFrameId === null) {
        this.animationFrameId = requestAnimationFrame(() => this.smoothAnimate());
      }
    }

    smoothAnimate() {
      const diff = this.targetProgress - this.currentProgress;
      if (Math.abs(diff) > 0.001) {
        this.currentProgress += diff * this.smoothFactor;
        this.applyAnimation(this.currentProgress);
        this.animationFrameId = requestAnimationFrame(() => this.smoothAnimate());
      } else {
        this.currentProgress = this.targetProgress;
        this.applyAnimation(this.currentProgress);
        this.animationFrameId = null;
      }
    }

    applyAnimation(progress) {
      const scaleFactor = this.getScaleFactor();
      const isDesktop = this.isDesktop();
      
      // 当 progress = 0 时，清除所有 JavaScript 设置的样式，让 CSS 初始位置生效
      if (progress === 0) {
        this.machineContainer.style.bottom = '';
        this.machineContainer.style.top = '';
        // 仍然需要处理 circles 的初始位置
        this.circles.forEach((circle, index) => {
          const circleNum = index + 1;
          const initialLeft = this.positions[`circle${circleNum}InitialLeft`];
          const initialTop = this.positions[`circle${circleNum}InitialTop`];
          const initialOpacity = this.positions[`circle${circleNum}InitialOpacity`];

          circle.style.left = '50%';
          circle.style.transform = `translateX(${initialLeft * scaleFactor}px)`;
          circle.style.top = `${initialTop * scaleFactor}px`;
          circle.style.opacity = initialOpacity;
        });
        return;
      }
      
      // progress > 0 时的正常动画逻辑
      // 移动端和桌面端都使用 bottom 定位
      let currentMachineBottom;
      
      currentMachineBottom =
        this.positions.machineInitialBottom +
        (this.positions.machineEndBottom - this.positions.machineInitialBottom) * progress;

      this.circles.forEach((circle, index) => {
        const circleNum = index + 1;
        const initialLeft = this.positions[`circle${circleNum}InitialLeft`];
        const initialTop = this.positions[`circle${circleNum}InitialTop`];
        const initialOpacity = this.positions[`circle${circleNum}InitialOpacity`];
        const endLeft = this.positions[`circle${circleNum}EndLeft`];
        const endTop = this.positions[`circle${circleNum}EndTop`];
        const endOpacity = this.positions[`circle${circleNum}EndOpacity`];

        const currentLeft = initialLeft + (endLeft - initialLeft) * progress;
        const currentTop = initialTop + (endTop - initialTop) * progress;
        const currentOpacity = initialOpacity + (endOpacity - initialOpacity) * progress;

        circle.style.left = '50%';
        circle.style.transform = `translateX(${currentLeft * scaleFactor}px)`;
        circle.style.top = `${currentTop * scaleFactor}px`;
        circle.style.opacity = currentOpacity;
      });

      // 统一使用 bottom 定位
      this.machineContainer.style.top = 'auto';
      this.machineContainer.style.bottom = `${currentMachineBottom * scaleFactor}px`;
    }

    handleResize() {
      const currentIsDesktop = this.isDesktop();
      // 在桌面/移动端切换或稳定高度变化时重新读取位置
      let positionsChanged = false;
      if (currentIsDesktop !== this.lastIsDesktop) {
        this.lastIsDesktop = currentIsDesktop;
        positionsChanged = true;
      }

      const stableHeightChanged = this.syncStableViewportHeight(false);
      // 如果稳定高度变化了，也需要重新计算 positions（因为 machineEndBottom 依赖稳定高度）
      if (stableHeightChanged) {
        positionsChanged = true;
      }

      if (positionsChanged) {
        this.positions = this.readPositions();
      }

      const nextProgress = this.calculateProgress();
      // iOS Safari 地址栏显示/隐藏会触发 resize：若进度几乎不变则不重复 applyAnimation，避免抖动/漂移
      const EPS = 0.001;
      if (!positionsChanged && !stableHeightChanged && Math.abs(nextProgress - this.currentProgress) < EPS) {
        this.updateLockedFeaturePosition();
        return;
      }

      this.currentProgress = nextProgress;
      this.targetProgress = nextProgress;
      this.applyAnimation(nextProgress);
      this.updateLockedFeaturePosition();
    }

    isTrackSticky() {
      const viewportHeight = this.stableViewportHeightPx || this.computeViewportHeightPx();
      const scrollTop = this.getScrollTop();
      const trackTop = this.getDocumentTop(this.track);
      const trackHeight = this.track.offsetHeight || 0;
      const trackBottom = trackTop + trackHeight;
      return scrollTop >= trackTop && scrollTop <= (trackBottom - viewportHeight);
    }

    getFeatureLockTopValue() {
      const h = this.stableViewportHeightPx || this.computeViewportHeightPx();
      return `${h}px`;
    }

    lockNextSection() {
      if (!this.nextSection || this.featureLocked) return;

      const placeholder = document.createElement('div');
      placeholder.className = 'feature-lock-placeholder';
      placeholder.style.height = `${this.nextSection.offsetHeight}px`;
      this.nextSectionPlaceholder = placeholder;
      this.nextSection.parentNode.insertBefore(placeholder, this.nextSection);

      this.nextSectionOriginalStyle = {
        position: this.nextSection.style.position || '',
        top: this.nextSection.style.top || '',
        left: this.nextSection.style.left || '',
        right: this.nextSection.style.right || '',
        width: this.nextSection.style.width || '',
        zIndex: this.nextSection.style.zIndex || '',
      };

      const topValue = this.getFeatureLockTopValue();
      Object.assign(this.nextSection.style, {
        position: 'fixed',
        top: topValue,
        left: '0',
        right: '0',
        width: '100%',
        zIndex: '1',
      });

      this.nextSection.classList.add('feature-locked');
      this.featureLocked = true;
    }

    unlockNextSection() {
      if (!this.featureLocked || !this.nextSection) return;

      this.nextSection.classList.remove('feature-locked');

      if (this.nextSectionOriginalStyle) {
        this.nextSection.style.position = this.nextSectionOriginalStyle.position;
        this.nextSection.style.top = this.nextSectionOriginalStyle.top;
        this.nextSection.style.left = this.nextSectionOriginalStyle.left;
        this.nextSection.style.right = this.nextSectionOriginalStyle.right;
        this.nextSection.style.width = this.nextSectionOriginalStyle.width;
        this.nextSection.style.zIndex = this.nextSectionOriginalStyle.zIndex;
      } else {
        this.nextSection.style.position = '';
        this.nextSection.style.top = '';
        this.nextSection.style.left = '';
        this.nextSection.style.right = '';
        this.nextSection.style.width = '';
        this.nextSection.style.zIndex = '';
      }

      if (this.nextSectionPlaceholder?.parentNode) {
        this.nextSectionPlaceholder.parentNode.removeChild(this.nextSectionPlaceholder);
      }

      this.nextSectionPlaceholder = null;
      this.nextSectionOriginalStyle = null;
      this.featureLocked = false;
    }

    updateLockedFeaturePosition() {
      if (!this.featureLocked || !this.nextSection) return;
      const topValue = this.getFeatureLockTopValue();
      this.nextSection.style.top = topValue;
    }
  }

  const instances = new Map();

  function initSection(track) {
    const sectionId = track.dataset.sectionId || track.id;
    if (!sectionId) return;
    if (instances.has(sectionId)) {
      instances.get(sectionId).destroy();
    }
    const instance = new MoveEffectSection(track);
    instances.set(sectionId, instance);
  }

  function destroySection(track) {
    const sectionId = track?.dataset?.sectionId || track?.id;
    if (!sectionId) return;
    const instance = instances.get(sectionId);
    if (instance) {
      instance.destroy();
      instances.delete(sectionId);
    }
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-move-effect-track]').forEach((track) => initSection(track));
  }

  // 固定移动端 viewport 高度，避免地址栏滑动导致的高度变化
  function lockViewportHeight() {
    // 只在移动端（< 990px）时执行
    if (window.innerWidth >= 990) return;
    
    const vh = window.innerHeight;
    document.documentElement.style.setProperty('--real-height', vh + 'px');
  }

  // 动态计算并设置 move effect 视口高度
  function updateMoveEffectViewportHeight() {
    // 只在桌面版（>= 990px）时计算
    if (window.innerWidth < 990) return;

    const minHeight = 700; // 最小高度限制（px）
    const actualViewportHeight = window.innerHeight;
    
    // 使用 100lvh 以避免 iOS 地址栏折叠导致的高度抖动
    let calculatedHeight;
    if (actualViewportHeight >= minHeight) {
      calculatedHeight = '100lvh';
    } else {
      calculatedHeight = `${minHeight}px`;
    }

    // 设置 CSS 变量
    document.documentElement.style.setProperty('--move-effect-viewport-height', calculatedHeight);
  }

  document.addEventListener('DOMContentLoaded', () => {
    setupScrollSave();
    // 已移除：不再应用持久化状态（取消回滚和伪元素隐藏）
    // applyPersistDone();
    lockViewportHeight(); // 固定移动端 viewport 高度（仅设置一次）
    updateMoveEffectViewportHeight(); // 初始化桌面端视口高度
    const loadType = getLoadType();
    if (loadType === 'back_forward') {
      // 返回场景：标记为返回导航
      isBackNavigation = true;
      // 已移除：不再折叠轨道
      // collapseAllTracks();
    } else {
      // 新加载/刷新：允许播放动效
      isBackNavigation = false;
      // 已移除：不再取消折叠状态
      // uncollapseAllTracks();
    }
    initAll();
  });

  // 监听窗口大小变化，更新视口高度
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      updateMoveEffectViewportHeight();
    }, 100);
  });

  // 从 bfcache 恢复（返回）时，确保保持折叠状态
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      // 标记为返回导航（bfcache 恢复）
      isBackNavigation = true;
      updateMoveEffectViewportHeight(); // 更新视口高度（视口大小可能已改变）
      // 已移除：不再应用持久化状态和折叠轨道
      // applyPersistDone();
      // collapseAllTracks();
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-move-effect-track]').forEach((track) => destroySection(track));
  });

  window.MerakiMoveEffect = {
    destroyAll() {
      instances.forEach((instance) => instance.destroy());
      instances.clear();
    },
  };
})();
